<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <table class="table table-sm table-hover BorcTable" style="margin: 0 !important;">
      <thead>
      <tr>
        <th>Sayaç No</th>
        <th>Sayaç Tipi</th>
        <th>Üretici</th>
        <th>G/Ç Sıcaklık</th>
        <th>İlk Okuma Tarihi</th>
        <th>İlk Okuma Endeks</th>
        <th>Son Okuma Tarihi</th>
        <th>Son Okuma Endeks</th>
        <th>Fark</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="s in Liste">
        <td>{{s.SayacNo}}</td>
        <td :class="s.STipi==='6'?'text-kirmizi':'text-mavi'"><b>{{s.STipi==='6'?'Sıcak Su':'Kalorimetre'}}</b>
        </td>
        <td>{{s.UreticiKodu}}</td>
        <td>{{s.GSicaklik}} - {{s.CSicaklik}}</td>
        <td>{{s.ITarihText}}</td>
        <td>{{s.IEndeksText}}</td>
        <td>{{s.STarihText}}</td>
        <td>{{s.SEndeksText}}</td>
        <td>{{s.Tuketim}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Yukleniyor from "../../../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: ['Mesken_id'],
    data() {
      return {
        lo: false,
        Liste: null
      }
    },
    methods: {
      SayfaYukle() {
        this.lo = true;

        this.$store.dispatch("Get", {path: '_enerji/dokum/detay/' + this.Mesken_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      },
    },
    created() {
      this.SayfaYukle()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/kisi/Ekran/KisiKalSayac.vue